module.exports = __webpack_public_path__ + "assets/3bd3c1696ad02e6fc4a48a14702c92ba.svg";